"use strict";

exports.onRouteUpdate = function (_ref) {
  var location = _ref.location;

  if (typeof twttr !== "undefined" && window.twttr.widgets && typeof window.twttr.widgets.load === "function") {
    window.twttr.widgets.load();
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-twitter/gatsby-browser.js
// module id = 395
// module chunks = 231608221292675